<template>
    <div class="container">
        <div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(200,200,200, 0.8)">
              <!-- 第1块 -->
            <div class="panelBlock">
                <div class="panelTitle">
                    <div class="innerLine">活动信息</div>
                </div>
                <div class="panelContent">
                    <el-row>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label">活动名称：</span>
                                <span class="text">{{basicInfo.conferenceName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <div class="itemBox">
                                <span class="label">活动主题：</span>
                                <span class="text">{{basicInfo.conferenceSubject}}</span>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <div class="itemBox">
                                <span class="label">活动介绍：</span>
                                <span class="text">{{basicInfo.conferenceIntro}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label">活动起止时间：</span>
                                <span class="text">{{basicInfo.hdTimeSpan}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label long">发布会起止时间：</span>
                                <span class="text">{{basicInfo.fbhTimeSpan}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label">邀请起止时间：</span>
                                <span class="text">{{basicInfo.yqTimespan}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label long">受邀报名起止时间：</span>
                                <span class="text">{{basicInfo.sybmTimeSpan}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label">入场起止时间：</span>
                                <span class="text">{{basicInfo.rcTimeSpan}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label longest">客户可查看线上展品起止时间：</span>
                                <span class="text">{{basicInfo.kckxszpTimeSpan}}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="itemBox">
                                <span class="label longest">允许客户下单起止时间：</span>
                                <span class="text">{{basicInfo.yxkhxdTimeSpan}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 第2块 -->
            <div class="panelBlock">
                <div class="panelTitle">
                    <div class="innerLine">申请人信息</div>
                </div>
                <div class="panelContent">
                    <el-row>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label">公司名称：</span>
                                <span class="text">{{basicInfo.companyName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label">联系人姓名：</span>
                                <span class="text">{{basicInfo.userName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label">注册手机号：</span>
                                <span class="text">{{basicInfo.userPhone}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label">联系人电话：</span>
                                <span class="text">{{basicInfo.phone}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label long">提交活动申请时间：</span>
                                <span class="text">{{basicInfo.adminSubmitTime}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label">身份：</span>
                                <span class="text">{{basicInfo.userType |turnValToText('user_type')}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label">身份认证状态：</span>
                                <span class="text">{{basicInfo.authResult|turnValToText('auth_result')}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="itemBox">
                                <span class="label">活动审核状态：</span>
                                <span class="text">
                                    <span v-if="basicInfo.hdshzt=='y'" class="green">已通过</span>
                                    <span v-if="basicInfo.hdshzt=='n'" class="orange_lighter">未通过</span>
                                    <span v-if="basicInfo.hdshzt=='p'" class="red">等待审批中</span>
                                </span>
                            </div>
                        </el-col>
                    </el-row>
                    <!-- <div class="historyTable">
                        <div class="title">历史审核记录</div>
                        <div class=" greyThead">
                            <el-table stripe :data="historyTableData" tooltip-effect="dark" style="width: 100%">
                                <el-table-column label="序号" width="50">
                                    <template slot-scope="scope">{{scope.$index+1}}</template>
                                </el-table-column>
                                <el-table-column label="审核操作账号" width="140">
                                    <template slot-scope="scope">{{ scope.row.name }}</template>
                                </el-table-column>
                                <el-table-column label="提交审核时间" width="170">
                                    <template slot-scope="scope">{{ scope.row.name }}</template>
                                </el-table-column>
                                <el-table-column label="审核操作时间" width="170">
                                    <template slot-scope="scope">{{ scope.row.name }}</template>
                                </el-table-column>
                                <el-table-column label="审核结果" width="170">
                                    <template slot-scope="scope">{{ scope.row.name |turnValToText("auth_result")}}</template>
                                </el-table-column>
                                <el-table-column label="说明">
                                    <template slot-scope="scope">{{ scope.row.name }}</template>
                                </el-table-column>

                            </el-table>

                        </div>
                    </div> -->
                </div>
            </div>
          
            <div class="buttonBox" v-if="basicInfo.hdshzt=='p'&&functionActiveApplyAuth">
                <el-button type="primary" size="mini" @click="clickYes">同意</el-button>
                <el-button type="danger" size="mini" @click="clickNo">拒绝</el-button>
            </div>

        </div>
    </div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                isLoading: false,
                historyTableData: [],
                basicInfo:{
                    conferenceName:'--', 
                    conferenceSubject :'--', 
                    conferenceIntro :'--', 
                    hdTimeSpan :'--', 
                    fbhTimeSpan :'--', 
                    yqTimespan :'--', 
                    sybmTimeSpan :'--', 
                    rcTimeSpan :'--', 
                    kckxszpTimeSpan:'--',  
                    yxkhxdTimeSpan :'--', 
                    companyName :'--', 
                    userName :'--', 
                    userPhone :'--', 
                    phone :'--', 
                    adminSubmitTime :'--', 
                    userType :'--', 
                    authResult :'--', 
                    hdshzt:'--', 
                },
                appId: "",
                conferenceId: "",
                invitePartnerId: "",
                inviteUserId: "",
            }
        },
        computed: {
            functionActiveApplyAuth(){
                return utils.getCurrentFunction().indexOf("activeApplyAuth")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            }
        },
        methods: {
            refreshPage(){
              this.getDetail()  
            },
            getParams() {
                // this.appId = this.$route.params.appId
                this.conferenceId = this.$route.params.conferenceId
                // this.invitePartnerId = this.$route.query.invitePartnerId
                // this.inviteUserId = this.$route.query.inviteUserId
            },
            getDetail() {
                let arg = {
                    // appId :this.appId,
                    conferenceId : this.conferenceId,
                    // invitePartnerId: this.invitePartnerId,
                    // inviteUserId: this.inviteUserId
                }
                let _this = this
                //
                ajaxPost('/admin/getconferenceReviewDetail', arg).then(function(res) {
                     
                     _this.basicInfo.companyName =res.data.companyName
                     _this.basicInfo.userName =res.data.userName
                     _this.basicInfo.userPhone =res.data.userPhone
                     _this.basicInfo.phone =res.data.phone
                     _this.basicInfo.adminSubmitTime =res.data.adminSubmitTime
                     _this.basicInfo.userType =res.data.userType
                     _this.basicInfo.authResult =res.data.authResult
                }, function(res) {
                   
                })
                ajaxPost('/admin/getconferenceinfo', arg).then(function(res) {
                     _this.basicInfo.conferenceName=res.data.conference_name
                     _this.basicInfo.conferenceSubject =res.data.conference_subject
                     _this.basicInfo.conferenceIntro =res.data.conference_intro
                     _this.basicInfo.hdTimeSpan =res.data.conference_global_start_time&&res.data.conference_global_end_time ? res.data.conference_global_start_time+' 至 '+res.data.conference_global_end_time :'-'
                     _this.basicInfo.fbhTimeSpan = res.data.conference_start_time&&res.data.conference_end_time ? res.data.conference_start_time+' 至 '+res.data.conference_end_time:'-'
                     _this.basicInfo.yqTimespan =res.data.conference_invite_start_time&&res.data.conference_invite_end_time ? res.data.conference_invite_start_time+' 至 '+res.data.conference_invite_end_time:'-'
                     _this.basicInfo.sybmTimeSpan =res.data.conference_register_start_time&&res.data.conference_register_end_time ? res.data.conference_register_start_time+' 至 '+res.data.conference_register_end_time:'-'
                     _this.basicInfo.rcTimeSpan =res.data.conference_checkin_start_time&&res.data.conference_checkin_end_time ? res.data.conference_checkin_start_time+' 至 '+res.data.conference_checkin_end_time:'-'
                     _this.basicInfo.kckxszpTimeSpan =res.data.conference_item_start_time&&res.data.conference_item_end_time ? res.data.conference_item_start_time+' 至  '+res.data.conference_item_end_time:'-'
                     _this.basicInfo.yxkhxdTimeSpan =res.data.conference_ordering_start_time&&res.data.conference_ordering_end_time ? res.data.conference_ordering_start_time+' 至  '+res.data.conference_ordering_end_time:'-'
                     _this.basicInfo.hdshzt=res.data.conference_state
                }, function(res) {
                   
                })
            },
            clickYes() {
                let _this = this
                this.$confirm('确认同意该申请吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let arg={
                        "conferenceId":_this.conferenceId,
                        "state":"y"
                    }
                    ajaxPost('/admin/updateConferenceStatus', arg).then(function(res) {
                        if(res.errorCode==200){
                            _this.$message({
                                message: "审批成功", //接口返回一个页面
                                type: 'success',
                                duration: 1000
                            });
                            _this.refreshPage()
                        }
                    }, function(res) {
                       
                    })
                    
                }).catch(() => {
                    console.log("点击取消了")
                });
            },
            clickNo() {
                let _this = this
                this.$prompt('*请输入拒绝理由(必填项)', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '理由不能为空'
                }).then(({
                    value
                }) => {
                    let refuseReson=value
                    let arg={
                        "conferenceId":_this.conferenceId,
                        "state":"n",
                        "memo":refuseReson
                    }
                    ajaxPost('/admin/updateConferenceStatus', arg).then(function(res) {
                        if(res.errorCode==200){
                            _this.$message({
                                message: "成功拒绝该申请", //接口返回一个页面
                                type: 'success',
                                duration: 1000
                            });
                            _this.refreshPage()
                        }
                    }, function(res) {
                       
                    })
                    
                }).catch(() => {});
            }
        },
        mounted() {
            this.historyTableData = json.tableData
            this.getParams()
            this.getDetail()
        },
        destroyed() {

        }
    }
</script>

<style scoped lang="scss">
    // * {        outline: 1px solid blue;    }
    .contentWrap {
        padding: 0.15rem 0.5rem;

        .itemBox {
            padding: 5px 0;
            display: flex;
            .label {
                color: #999;
                display: inline-block;
                width: 100px;
            }

            .label.long {
                width: 130px;
            }

            .label.longest {
                width: 200px;
            }

            .text {
                color: #000; display: inline-block;flex: 1;
                ;
            }
        }

        .buttonBox {
            padding: 20px 0 60px;
            text-align: center;
        }
    }

    .panelBlock {
        .panelTitle {
            padding: 0.7rem 0 0.3rem;
            color: #4C4C4C;

            .innerLine {
                border-left: 4px solid lightblue;
                font-size: 17px;
                padding-left: 0.25rem;
            }
        }

        .panelContent {
            background: #fff;
            padding: 10px;
            font-size: 14px;

            .historyTable {
                padding: 10px;

                .title {
                    padding: 10px;
                }

                .greyThead {
                    border: 1px solid #eaeaea;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/authDetail.vue